import React, { useEffect, useRef, useState } from "react";
import { MISSIONS } from "../mock";
import Reveal from "./Reveal";

const MissionRow = ({ m, show, completed }) => (
  <div className="rounded-xl border border-[#29354A] bg-[#0A1220] p-5">
    <div className="flex items-center justify-between mb-3">
      <p className="font-medium text-[#F5F7FB]">{m.title}</p>
      <span className="text-xs text-[#8290A8]">{m.due}</span>
    </div>
    <div className="h-2.5 rounded-full bg-[#172031] overflow-hidden mb-2">
      <div
        className="h-full rounded-full bg-gradient-to-r from-[#10C98A] to-[#9EF2CF]"
        style={{ width: show ? `${m.pct}%` : "0%", transition: "width 1.1s cubic-bezier(0.22,1,0.36,1)" }}
      />
    </div>
    <div className="flex items-center justify-between text-sm">
      <span className="text-[#8290A8]">
        {completed ? "Complete" : `$${m.current.toLocaleString()} of $${m.target.toLocaleString()}`}
      </span>
      <span className="font-semibold text-[#13D99A]">{m.pct}%</span>
    </div>
  </div>
);

const Missions = () => {
  const [tab, setTab] = useState("active");
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { setShow(true); obs.disconnect(); } });
    }, { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const list = tab === "active" ? MISSIONS.active : MISSIONS.completed;

  return (
    <section id="missions" className="relative py-20 lg:py-28 bg-[#0A1220]">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Missions</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {MISSIONS.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{MISSIONS.copy}</p>
          <p className="mt-6 text-sm text-[#8290A8]">{MISSIONS.note}</p>
        </Reveal>

        <Reveal delay={100}>
          <div ref={ref} className="rounded-2xl border border-[#29354A] bg-[#121A28] p-6">
            <div className="flex gap-2 mb-6 bg-[#0A1220] p-1 rounded-full w-max">
              {["active", "completed"].map((t) => (
                <button
                  key={t}
                  onClick={() => setTab(t)}
                  className={`px-4 py-2 rounded-full text-sm font-medium capitalize transition-colors ${
                    tab === t ? "bg-[#10C98A] text-[#050A12]" : "text-[#8290A8] hover:text-[#F5F7FB]"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
            <div className="space-y-4">
              {list.map((m) => (
                <MissionRow key={m.title} m={m} show={show} completed={tab === "completed"} />
              ))}
            </div>
            <p className="mt-4 text-[11px] text-[#8290A8]/70">Example data</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Missions;
